<template>
  <div class="main_wrap">
    <h3>
      我的收藏
      <template v-if="courseList.length"> ({{ courseList.length }}) </template>
    </h3>
    <template v-if="courseList.length">
      <div class="main_list">
        <div
          class="course_item"
          v-for="(item, index) in courseList"
          :key="index"
          href="#"
          @click.prevent="jumpTo(item)"
        >
          <div
            class="course_section"
            :style="`opacity:${item.delFlag ? '0.6' : '1'}`"
          >
            <div class="course_cover_wrap">
              <el-image
                class="course_cover"
                :src="getCoverImage(item)"
                fit="cover"
              >
                <div class="error_img" slot="error" />
              </el-image>
            </div>
            <div class="course_info">
              <div class="course_title">{{ item.name }}</div>
              <div class="course_intro">
                <div class="course_type">
                  分类：{{ item.courseTypeName || item.provinceCourseTypeName }}
                </div>
                <div class="course_grade">
                  年级：{{ grade(item.courseGradeTermList) }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="course_collected"
            v-if="!item.delFlag"
            @click.stop="changeCollected(item)"
          >
            <template v-if="item.ifCollected">
              <div class="if_collected">取消收藏</div>
              <div class="img_collected"></div>
            </template>
            <template v-else>
              <div class="if_collected">收藏</div>
              <div class="img_uncollected"></div>
            </template>
          </div>
          <div class="course_disabled" v-else>
            <el-image
              class="course_cover"
              :src="require('@/assets/images/course_disabled.png')"
              fit="cover"
            >
            </el-image>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <el-empty
        :image="require('@/assets/images/collectionEmpty.png')"
        description="暂无收藏哟~"
      ></el-empty>
    </template>
  </div>
</template>

<script>
import {
  getUserFavoriteList,
  unfavoriteCourse,
  favoriteCourse,
} from "@/api/mine.js";
import { getGrade } from "@/utils/common";

export default {
  name: "myCollection",
  data: function () {
    return {
      courseList: [],
      grades: [],
    };
  },
  methods: {
    getGrade,
    //跳转至课程
    jumpTo(item) {
      let path = ``;
      if (!item.delFlag) {
        //判断是不是 作业看管课
        if (item.teachingAuxiliaryId)
          path = `/course/subjectDetail/${item.id}?teachingAuxiliaryId=${
            item.teachingAuxiliaryId
          }&from=collection&target=${item.courseFinishTag ? "intro" : "resourse"}`;
        else
          path = `/course/detail/${item.id}?from=collection&target=${
            item.courseFinishTag ? "intro" : "resourse"
          }`;
      } else {
        path = `/course/courseDeleted`;
        const params = {
          targetId: item.id,
          targetType: "course",
        };
        unfavoriteCourse(params)
          .then(() => {})
          .catch(() => {});
      }
      this.$router.push(path);
    },
    //弹窗
    showMessage(message, type) {
      this.$message({
        message,
        type,
        offset: 120,
        customClass: "errorTips",
      });
    },
    changeCollected(item) {
      const params = {
        targetId: item.id,
        targetType: "course",
      };
      if (item.ifCollected) {
        unfavoriteCourse(params)
          .then(() => {
            this.showMessage("取消成功", "success");
          })
          .catch(() => {
            this.showMessage("操作失败", "error");
          });
        item.ifCollected = !item.ifCollected;
      } else {
        favoriteCourse(params)
          .then(() => {
            this.showMessage("收藏成功", "success");
          })
          .catch(() => {
            this.showMessage("操作失败", "error");
          });
        item.ifCollected = !item.ifCollected;
      }
    },

    //获取用户收藏数据
    async loadData() {
      const targetType = "course";
      const data = await getUserFavoriteList(targetType);
      data.map((item) => {
        item.ifCollected = true;
      });
      this.courseList = data;
    },
    //获取每项的年级
    grade(courseGradeTermList) {
      if (courseGradeTermList) {
        const gradeArr = courseGradeTermList.map((item) => {
          return item.grade;
        });
        return getGrade(gradeArr);
      } else return "-";
    },
    getCoverImage(item) {
      if (item.introVideoThumbnail) return item.introVideoThumbnail;
      else if (item.coverImgUrls && item.coverImgUrls.length > 0)
        return item.coverImgUrls[0];
      else return "";
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
<style lang="scss" scoped>
.main_wrap {
  h3 {
    font-size: 2rem;
  }
  .main_list {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: repeat(auto-fill, 17rem);
    grid-gap: 2.5rem;
    .course_item {
      overflow: hidden;
      text-decoration: none;
      border: solid 2px #ffffff;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      height: 13rem;
      background: #ffffff;
      border-radius: 0.4rem;
      padding: 1.9rem;
      position: relative;

      .course_section {
        height: 85%;
        display: flex;
        user-select: none;
        .course_cover_wrap {
          width: 20.4rem;
          border-radius: 0.4rem;
          position: relative;
          overflow: hidden;
          .course_tag {
            position: absolute;
            bottom: 0;
            left: 0;
            line-height: 50px;
          }
          .course_cover {
            width: 100%;
            height: 100%;
          }
        }
        .course_info {
          flex: 1;
          margin-left: 1.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 0.5rem 0;
          overflow: hidden;
          .course_title {
            font-size: 1.8rem;
            font-weight: bold;
            color: #000000;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .course_intro {
            color: #666666;
            font-size: 1.4rem;
            .course_type {
              margin-bottom: 1rem;
              white-space: nowrap;
            }
          }
        }
      }
      .course_collected {
        margin-top: 0.5rem;
        width: auto;
        height: auto;

        /* 放大 */
        @keyframes enlarge {
          0% {
            transform: scale(0.8);
          }
          100% {
            transform: scale(1.35);
          }
        }

        .img_collected {
          background: url("~@/assets/icons/collected.png");
          animation: enlarge 0.2s ease 0s 2 alternate;
        }
        .img_uncollected {
          background: url("~@/assets/icons/uncollected.png");
        }
        .img_collected,
        .img_uncollected {
          float: right;
          margin-right: 0.5rem;
          width: 2rem;
          height: 2rem;
          background-repeat: no-repeat;
          background-size: 100%;
        }

        .if_collected {
          line-height: 2rem;
          font-size: 1.6rem;
          float: right;
          color: #000000;
        }
      }

      .course_disabled {
        width: 10rem;
        height: auto;
        position: absolute;
        right: 1rem;
        bottom: 1rem;
      }
    }
    .course_item:hover,
    .course_item:active {
      border: solid 2px $color-primary;
      box-shadow: 0 0.4rem 2rem 0 rgba(31, 31, 31, 0.1);
      .course_title {
        color: $color-primary !important;
      }
    }
  }
}
</style>